"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Input = require("@ccw-pwa-ui/Input");
var _Switch = require("@ccw-pwa-ui/Switch");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Header = require("@ccw-pwa-ui/Header");
require("../styles/NotificationPreferences.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
var _Checkbox = require("@ccw-pwa-ui/Checkbox");
const NotificationPreferencesComponent = props => {
  var _props$phoneNumber;
  const numLength = ((_props$phoneNumber = props.phoneNumber) === null || _props$phoneNumber === void 0 ? void 0 : _props$phoneNumber.length) > 10 ? "phone-input1" : "phone-input2";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-screen"
  }, props.reInviteModalNotifyPref && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: props.inviteModalVarientNP,
    modalHeaderText: props.modalHeaderTextNotifyPref,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: "#333333",
      fontWeight: 600,
      lineHeight: "25px"
    },
    modalDetailText: props.modalDetailTextNotifyPref,
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px"
    },
    displayModal: props.reInviteModalNotifyPref,
    positiveActionButtonTitle: props.positiveActionButtonTitleNotifyPref,
    negativeButtonActionTitle: props.negativeButtonActionTitleNotifyPref,
    positiveAction: props.handleResendInviteModalNP,
    negativeAvtion: props.handleSetReInviteCancelModalNP
  }), props.isHeaderVisible ? /*#__PURE__*/_react.default.createElement(_Header.Header, {
    imageUrl: props.headerImage,
    imageStyle: {
      height: 30,
      maxWidth: 100
    }
  }) : null, props.fromEditProfile ? /*#__PURE__*/_react.default.createElement("div", {
    className: "back-navigation"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: props.backNavigationScreen,
    handleBack: props.handleBack,
    leftArrowImage: _index.default.leftArrow.default
  })) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    style: {
      maxWidth: 480,
      padding: "10px 25px"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-image ".concat(!props.fromEditProfile ? "onboard-notification-image" : "")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: props.NotificationImage
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-screen-detail"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "simple-text",
    headerText: props.headerSubText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-notification-container",
    "data-testid": "email-checked"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.emailNotificationsText
  }), /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    defaultChecked: props.defaultChecked,
    checked: props.emailChecked,
    disabled: props.disabled,
    onChange: props.changeEmailChecked
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sms-notification-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sms-notification-container",
    "data-testid": "sms-checked"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.smsNotificationsText
  }), props.isPending ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 13,
      color: "#333333",
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.pendingText
  }) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(props.isPending ? "switch-button-sms" : "", " \"switch-button-sms2\"")
  }, /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    defaultChecked: props.defaultChecked,
    checked: props.smsChecked,
    disabled: props.disabled,
    onChange: props.changeSmsChecked
  })))), props.isSmsSelected ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 24,
      position: 'relative'
    },
    "data-testid": "phone-input"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: props.numberDisabled,
    country: "us",
    dynamicTitleStyle: {
      color: "#333333",
      fontSize: 16
    },
    inputTitle: props.phoneNumberText,
    inputType: "phone-input",
    notificationText: props.notificationSubText,
    value: props.phoneNumber,
    onchange: props.onChangePhoneNumber,
    placeholder: "enter number",
    isValidPhoneNumber: props.isValidPhoneNumber,
    phoneNumberInputClass: "".concat(props.numberDisabled ? "phone-input-disabled" : numLength),
    numberInvalidText: props.numberInvalidText,
    countryCodeEditable: false,
    onlyCountries: ['us'],
    disableDropdown: true
  }), !props.isValidPhoneNumber ? /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warning"
  }) : null) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-tips-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginRight: 10
    },
    "data-testid": "checkbox-checked"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: props.checkboxChecked,
    onChange: props.changeCheckBox
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.checkboxContentText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "accept-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.saveButtonText,
    onClick: props.onClickSave,
    disabled: props.onClickSaveDisabled
  })))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = NotificationPreferencesComponent;